const getPersonalFamilyInfo = (state) => state?.home?.personalFamily?.info;
const hasFTNumberedFamily = (state) => state?.family?.content;

export { getPersonalFamilyInfo, hasFTNumberedFamily };
